export { HasEntities } from './HasEntities';
